<!--
/*******************************************************************************
*@ 컴포넌트명   : StandingApproval.vue
*@ 컴포넌트설명 : 결재진행내역
*@ 사용전문     : RBF0404F40 - 결재대상목록조회
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <common-grid
    ref="commonGrid"
    :list="GL5040101Response.dataGrid"
    :total-line-cnt="GL5040101Response.totalCnt"
    :scroll-event="true"
    :tagType="'div'"
    :totalCss="['total-count', 'no-border']"
    @reSearch="scrollEvent"
  >
    <template v-slot:list="data">
      <div class="box-white -type4">
        <div class="header">
          <div class="title" @click="goToDetail(data.row)">
            {{$t(`${data.row.corpBzwkCd}_결재선사용거래`)}}
            <i class="icon icon-arrow-m-right" />
            <div class="state ing" v-if="data.row.aprvalDmndDstcd == '0'">{{$t("2_결재상태구분")}}</div>
            <div class="state wait" v-else>{{$t("1_결재상태구분")}}</div>
          </div>
          <div class="desc">
            <div class="item account">
              {{/*건수*/$t("PCOP-02-01-01-07")}} :
              {{data.row.trsaccRqstNoitm}}
            </div>
          </div>
        </div>
        <div class="content">
          <div class="account-info -type3">
            <div class="item amount">
              <span class="exchange-unit">{{data.row.trsaccCncycd}}</span>
              <span class="total" v-html="$num(data.row.trsaccAmt, null,true)"></span>
            </div>
            <div class="item sub">
              <div class="cont" v-if=" isView(data.row.corpBzwkCd)">
                <span class="tit">{{/*출금계좌번호*/$t("PCOP-02-01-01-08")}}</span>
                <span class="dec">{{data.row.drwotAcno}}</span>
              </div>
              <div class="cont">
                <span class="tit">{{/*등록자*/$t("PCOP-02-01-01-09")}}</span>
                <span class="dec">{{data.row.aprvalRegiCustnm}}</span>
              </div>
              <div class="cont">
                <span class="tit">{{/*등록 일시*/$t("PCOP-02-01-01-10")}}</span>
                <span
                  class="dec"
                >{{$getGlobalDateFmt(data.row.regiYmd)}} {{$getGlobalTimeFmt(data.row.regiYms)}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </common-grid>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import CommonGrid from "@/components/page/common/CommonGrid";
import { aprvalParam, approvalCertification } from "@/mixins/approval";
export default {
  mixins: [aprvalParam, approvalCertification],
  props: {
    type: {
      type: String,
    },
  },
  components: {
    CommonGrid,
  },
  computed: {
    ...mapFields("admin/approvalInfo", ["approvalSearch", "approvalInfo", "aprvalCnt"]),
  },
  mounted() {
    this.searchData = { ...this.approvalSearch };
    this.RBF0404F40Call(this.approvalSearch.page);
  },
  data() {
    return {
      GL5040101Response: {
        totalCnt: 0,
        dataGrid: [],
      },
      call: true,
    };
  },
  methods: {
    isView(corpBzwkCd) {
      if (
        corpBzwkCd == this.$config.CORP_BZWK_APRVALCD_140001 ||
        corpBzwkCd == this.$config.CORP_BZWK_APRVALCD_140002 ||
        corpBzwkCd == this.$config.CORP_BZWK_APRVALCD_140003 ||
        corpBzwkCd == this.$config.CORP_BZWK_APRVALCD_140004 ||
        corpBzwkCd == this.$config.CORP_BZWK_APRVALCD_140005 ||
        corpBzwkCd == this.$config.CORP_BZWK_APRVALCD_140006
      ) {
        return false;
      } else {
        return true;
      }
    },
    //스크롤 마지막 이벤트
    scrollEvent() {
      if (this.approvalSearch.page * 10 < this.GL5040101Response.totalCnt) {
        this.RBF0404F40Call();
      }
    },
    RBF0404F40Call(page) {
      if (this.call) {
        if (page == null) {
          this.approvalSearch.page++;
        } else {
          this.approvalSearch.page = 1;
        }
        this.call = false;
        let param = {};
        if (this.type == "1") {
          /* 결재대상 목록 조회 */
          param = {
            tranDstcd: this.$config.TRAN_DSTCD_1, //거래구분코드
            dmndPageCntNo: String(this.approvalSearch.page),
            pageLineCnt: 10,
            subIdDsticCd: this.subIdDsticCd, //SUBID구분코드
            mainWwwBnkgLginId: this.mainWwwBnkgLginId, //주인터넷뱅킹로그인ID
            wwwBnkgLginId: this.wwwBnkgLginId, //인터넷뱅킹로그인ID
          };
        } else if (this.type == "2") {
          /* 등록내역 목록 조회 */
          param = {
            tranDstcd: this.$config.TRAN_DSTCD_2, //거래구분코드
            dmndPageCntNo: String(this.approvalSearch.page),
            pageLineCnt: 10,
            subIdDsticCd: this.subIdDsticCd, //SUBID구분코드
            mainWwwBnkgLginId: this.mainWwwBnkgLginId, //주인터넷뱅킹로그인ID
            wwwBnkgLginId: this.subIdDsticCd == "1" ? this.mainWwwBnkgLginId : this.wwwBnkgLginId, //인터넷뱅킹로그인ID
            regiWwwBnkgLginId: this.regiWwwBnkgLginId, //등록자
            aprvalStus: this.searchData.aprvalStus, //결재상태
            regiList: "1",
          };
        } else {
          /* 진행중인 결재 목록 조회 */
          this.searchData.aprvalStus = "0";
          if (this.subIdDsticCd == "1") {
            this.wwwBnkgLginId = this.mainWwwBnkgLginId;
          }
          param = {
            tranDstcd: this.$config.TRAN_DSTCD_2, //거래구분코드
            dmndPageCntNo: String(this.approvalSearch.page),
            pageLineCnt: 10,
            subIdDsticCd: this.subIdDsticCd, //SUBID구분코드
            mainWwwBnkgLginId: this.mainWwwBnkgLginId, //주인터넷뱅킹로그인ID
            wwwBnkgLginId: this.subIdDsticCd == "1" ? this.mainWwwBnkgLginId : this.wwwBnkgLginId, //인터넷뱅킹로그인ID
            aprvalStus: this.searchData.aprvalStus, //결재상태
            regiList: "2",
          };
        }
        this.$post("/customer/aprv/AprvalPrgrsInq", param, this.RBF0404F40Suc);
      }
    },
    RBF0404F40Suc(res) {
      this.GL5040101Response.totalCnt = res.outItem.totalCnt;
      this.aprvalCnt = this.GL5040101Response.totalCnt; //결재할 내역 건 수
      if (this.GL5040101Response.totalCnt > 0) {
        if (this.approvalSearch.page === 1) {
          this.GL5040101Response.dataGrid = [...res.outItem.dataGrid];
        } else {
          this.GL5040101Response.dataGrid = [...this.GL5040101Response.dataGrid, ...res.outItem.dataGrid];
        }
        this.$refs.commonGrid.changeList(this.GL5040101Response.dataGrid);
      }
      this.call = true;
    },
    goToDetail(item) {
      this.approvalInfo = item;
      this.$router.push({ name: "standingDetail", params: { name: this.$route.name, type: this.type } });
    },
  },
};
</script>